import { type SyntheticEvent, useMemo } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	DEFAULT_NOTIFICATION_CENTER_TAB,
	NOTIFICATION_CENTER_TAB_ORDER,
	NOTIFICATION_CENTER_TABS,
	type NotificationCenterTab,
} from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";

export const useNotificationCenterTabs = (
	activeTab: NotificationCenterTab,
	onTabChange: (tab: NotificationCenterTab) => void,
) => {
	const { t } = useResource();

	const tabs = useMemo(
		() => [
			{
				id: NOTIFICATION_CENTER_TABS.Upcoming,
				label: t(Resources.NotificationCenter.Tabs.Upcoming),
			},
			{
				id: NOTIFICATION_CENTER_TABS.Recent,
				label: t(Resources.NotificationCenter.Tabs.Recent),
			},
		],
		[t],
	);

	const onChange = (_event: SyntheticEvent, index: number) =>
		onTabChange(
			NOTIFICATION_CENTER_TAB_ORDER[index] ?? DEFAULT_NOTIFICATION_CENTER_TAB,
		);

	return {
		tabs,
		value: NOTIFICATION_CENTER_TAB_ORDER.indexOf(activeTab),
		onChange,
	};
};
